import React, { useMemo, useState } from 'react';
import { useLocation } from 'react-router';
import { CheckEmailMFA } from './components/check-email-MFA.component';
import { LoginFooter } from './components/login-footer.component';
import { LoginForm } from './components/login-form.component';
import { LoginHeader } from './components/login-header.component';
import { UserContact } from '@uplift/types';
import { MFAChallenge } from './components/mfa-challenge';

type MFAInfo = {
  contacts: UserContact[];
  email: string;
  userId: string;
  requestId: string;
};

export const LoginPage = () => {
  const location = useLocation();
  const [ checkEmail, setCheckEmail ] = useState<string | null>(null);
  const [ mfaInfo, setMfaInfo ] = useState<MFAInfo | null>(null);

  const searchParams = useMemo(() => new URLSearchParams(location.search), [ location.search ]);

  const loginHandler = React.useCallback((redirectUrl: string, code: string) => {
    window.location.replace(`${redirectUrl}?code=${code}`);
  }, []);

  const onCheckEmailHandler = (email: string) => {
    setCheckEmail(email);
  };

  const handleMfaChallenge = (userId: string, email: string, contacts: UserContact[], requestId: string) => {
    setMfaInfo({
      contacts,
      email,
      userId,
      requestId
    });
  };

  const handleMfaClose = () => {
    setMfaInfo(null);
  };

  const isAutoSignOut = !!searchParams.get('privacy_alert');

  if (checkEmail) {
    return <CheckEmailMFA email={checkEmail} />;
  }

  return (
    <>
      <LoginHeader isAutoSignOut={isAutoSignOut} />
      <LoginForm
        onSubmit={loginHandler}
        onCheckEmail={onCheckEmailHandler}
        onMfaChallenge={handleMfaChallenge}
      />
      <LoginFooter isAutoSignOut={isAutoSignOut} />
      {mfaInfo && (
        <MFAChallenge
          {...mfaInfo}
          onClose={handleMfaClose}
          onSuccess={loginHandler}
        />
      )}
    </>
  );
};
